export const getAbilityList = (data) => {

    const permissionList = [];
    // permissionList.push({
    //     action: 'manage',
    //     subject: 'dashboard'
    // })
    //
    // if (!data?.roleResponse?.isSuper) {
    //     if (data?.roleResponse?.viewPermissionList) {
    //         data?.roleResponse.viewPermissionList.map((permission) => {
    //             if (permission) {
    //                 permissionList.push({
    //                     action: 'manage',
    //                     subject: permission.value
    //                 })
    //             }
    //         })
    //     }
    // } else {

        permissionList.push({
            action: "manage",
            subject: "all"
        })
    // }
    return permissionList;
}

export const getActionPermissionList = (data) => {

    const actionList = [];

    // if (!data?.roleResponse?.isSuper) {
    //     if (data?.roleResponse?.actionPermissionList) {
    //         data?.roleResponse.actionPermissionList.map((permission) => {
    //             if (permission) {
    //                 actionList.push(permission.value)
    //             }
    //         })
    //     }
    // } else {
        actionList.push('all')
    // }
    return actionList;
}

export const isButtonHasAccess = (btnAction) => {

    const actionList = JSON.parse(localStorage.getItem('action_permission'))

    if (btnAction) {
        if (actionList && actionList.length > 0) {
            if (actionList.length === 1 && actionList[0] && actionList[0] === "all") {
                return true
            } else if (actionList.includes(btnAction)) {
                return true
            }
        }
    }
    return false
}
